import moment from 'moment-timezone';

/**
 * Resolve the timezone to use for account metrics.
 *
 * Falls back to the browser's guessed timezone whenever the dashboard account
 * has not loaded or has no timezone set. Passing a falsy value to
 * `moment().tz()` turns it into a getter that returns `undefined`, which then
 * throws on the next chained call (e.g. `.subtract`).
 */
const resolveDashboardTimezone = (dashboardAccount: { timezone?: string | null } | null | undefined): string =>
    dashboardAccount?.timezone || moment.tz.guess();

export default resolveDashboardTimezone;
